import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import React, { useState } from 'react';

import { CalculationType } from '@pflegia/types/api/job-position/calculation-type.enum';

interface SalaryTabsProps {
  setCalculationType(type: CalculationType): void;
  fullTimeHours: number;
}

export const SalaryTabs: React.FC<SalaryTabsProps> = ({ setCalculationType, fullTimeHours }) => {
  const { t } = useTranslation('jobDetails', { keyPrefix: 'salaryDetails' });
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (index: number, type: CalculationType) => {
    setCalculationType(type);
    setActiveTab(index);
  };

  const tabs = [
    {
      index: 1,
      title: t('perMonth'),
      calculationType: CalculationType.Monthly,
    },
    { index: 2, title: t('perYear'), calculationType: CalculationType.Yearly },
  ];

  if (fullTimeHours && fullTimeHours > 0) {
    tabs.unshift({
      index: 0,
      title: t('perHour'),
      calculationType: CalculationType.Hourly,
    });
  }
  return (
    <>
      {tabs.map(tab => (
        <button
          key={tab.title}
          className={clsx(
            'text-normal text-default mr-6 text-center md:mr-8 md:text-left',
            activeTab === tab.index ? 'font-semibold' : 'font-normal',
          )}
          onClick={() => handleTabClick(tab.index, tab.calculationType)}>
          {tab.title}
        </button>
      ))}
    </>
  );
};

export default SalaryTabs;
